import { isTrue } from '@avantia/client-and-server-utilities';
import { lodash } from '@avantia/lodash';
import { toClientDebugFlags } from '../clientLogging';
import { ClientConfiguration } from './configurationTypes';

export function getConfig(): ClientConfiguration {
  const virtualPath = lodash.trimEnd('/', '/');
  const config: ClientConfiguration = {
    agentUpdatePolicyEnabled: isTrue('false'),
    assetsUrl: 'https://assets.homeprotect.co.uk/',
    azureAdClientId: '78a4300b-ad0f-48de-952a-c4a8264f717f',
    azureAdTenantId: 'fac35918-f111-49f4-889d-e209be7ea18d',
    claimsPortalUrl: 'https://claim.homeprotect.co.uk',
    clientDebugFlags: toClientDebugFlags('None'),
    customerRenewalEnabled: isTrue('true'),
    ddApplicationId: '8e45e33f-f6bb-4138-995a-984f623f65ba',
    ddClientToken: 'pub38bca0d2ad537ca220dce1ee5a40a481',
    ddCompressInTakeRequests: isTrue('true'),
    ddRumEnabled: isTrue('true'),
    ddRumSessionRecordingEnabled: isTrue('true'),
    ddSampleRate: parseInt('100', 10),
    ddServiceName: 'homeprotectcustomerportal',
    ddSessionReplaySampleRate: parseInt('100', 10),
    ddTrackInteractions: isTrue('true'),
    ddUsePartitionedCrossSiteSessionCookie: isTrue('true'),
    developerModeEnabled: isTrue('false'),
    editableRenewalEnabled: isTrue('false'),
    environment: 'liv',
    homeProtectUrl: 'https://homeprotect.co.uk',
    logoPath: 'website/homeprotect_final_logo.svg',
    makeChangesEnabled: isTrue('true'),
    paymentPortalUrl: 'https://payment.homeprotect.co.uk'.replace(/\/$/, ''),
    policyPortalUrl: 'https://policy.homeprotect.co.uk'.replace(/\/$/, ''),
    quoteJourneyWebUrl: 'https://quotes.homeprotect.co.uk'.replace(/\/$/, ''),
    releaseVersion: '1.0.513.260334',
    schemeAndHost: 'https://customers.homeprotect.co.uk',
    websiteBaseUrl: 'https://customers.homeprotect.co.uk',
    websiteEndpoint: virtualPath
  };

  return config;
}
